// ApiKeyService — migrated to the OpenAPI-generated client (AdminApiKeyController /admin/api-keys).
// Each function keeps its old return shape (callers read res.data / res.data.url) — the adapter
// returns `{data}` and re-throws an axios-shaped `{response:{data,status}}` on error. Auth/timezone
// headers come from configureApi's interceptor.

import {
    adminApiKeyControllerList,
    adminApiKeyControllerCreate,
    adminApiKeyControllerUpdate,
    adminApiKeyControllerDelete,
    adminApiKeyControllerGetDocsUrl,
} from '../api/generated';

// Preserve the legacy axios rejection shape so call sites reading `e.response.data.errorCode` keep working.
const throwLikeAxios = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export const listApiKeys = async (companyId) => {
    const {data, error, response} = await adminApiKeyControllerList({
        query: companyId ? {companyId} : {},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const createApiKey = async (body, companyId) => {
    const {data, error, response} = await adminApiKeyControllerCreate({
        body,
        query: companyId ? {companyId} : {},
    });
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const updateApiKey = async (id, body) => {
    const {data, error, response} = await adminApiKeyControllerUpdate({path: {id}, body});
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const deleteApiKey = async (id) => {
    const {data, error, response} = await adminApiKeyControllerDelete({path: {id}});
    if (error) throwLikeAxios(error, response);
    return {data};
};

export const getApiKeysDocsUrl = async () => {
    const {data, error, response} = await adminApiKeyControllerGetDocsUrl();
    if (error) throwLikeAxios(error, response);
    return {data};
};
